import React from "react";

// Minimal markdown for assistant chat text (port of aidea.console newchat/miniMarkdown.tsx):
// **bold**, *italic*, `code`, "#" headings (as bold), "-"/"*"/"1." lists; line breaks stay
// as text for the parent's whitespace-pre-wrap. React elements only, so any HTML in the
// text renders as literal text — no innerHTML. Unmatched */** markers are dropped.
// ponytail: no links/tables/nesting; add a real parser if the agent starts emitting them.

const INLINE = /(\*\*[^*\n]+\*\*|`[^`\n]+`|\*[^*\s][^*\n]*\*)/;
// A leftover marker touches a word ("***x" → "*" before x); a lone " * " stays.
const STRAY = /\*+(?=\S)|([^\s*])\*+/g;

function inline(text) {
  const toks = text.split(INLINE);
  return toks.map((tok, i) => {
    if (i % 2 === 0) {
      // Also a run right next to a matched token ("**" + "*x*" leaves a lone "*").
      let t = tok.replace(STRAY, "$1");
      if (i > 0) t = t.replace(/^\*+/, "");
      if (i < toks.length - 1) t = t.replace(/\*+$/, "");
      return t;
    }
    if (tok.startsWith("**")) return <strong key={i}>{inline(tok.slice(2, -2))}</strong>;
    if (tok.startsWith("`")) return <code key={i}>{tok.slice(1, -1)}</code>;
    return <em key={i}>{inline(tok.slice(1, -1))}</em>;
  });
}

const BULLET = /^\s*[-*•]\s+(.*)$/;
const NUMBERED = /^\s*\d+[.)]\s+(.*)$/;
const HEADING = /^#{1,6}\s+(.*)$/;

export function renderMiniMarkdown(text) {
  const out = [];
  const lines = String(text || "")
    .replace(/\*{3,}/g, "**") // "***x**" / "***x***" → bold
    .split("\n");
  let para = [];
  const flush = () => {
    if (para.length) out.push(<span key={out.length}>{inline(para.join("\n"))}</span>);
    para = [];
  };
  for (let i = 0; i < lines.length; ) {
    const kind = BULLET.test(lines[i]) ? BULLET : NUMBERED.test(lines[i]) ? NUMBERED : null;
    if (kind) {
      flush();
      const items = [];
      while (i < lines.length && kind.test(lines[i])) items.push(lines[i++].match(kind)[1]);
      const List = kind === BULLET ? "ul" : "ol";
      out.push(
        <List key={out.length} className={`tw-my-1 tw-pl-5 ${kind === BULLET ? "tw-list-disc" : "tw-list-decimal"}`}>
          {items.map((it, j) => (
            <li key={j}>{inline(it)}</li>
          ))}
        </List>
      );
      continue;
    }
    const h = lines[i].match(HEADING);
    para.push(h ? `**${h[1]}**` : lines[i]);
    i++;
  }
  flush();
  return out;
}
